import { render, staticRenderFns } from "./sales_channel.vue?vue&type=template&id=0d6e6cb3"
import script from "./sales_channel.vue?vue&type=script&lang=js"
export * from "./sales_channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports